import moment from "moment";
import { ReportType } from "../components/reports/ReportPage";
import FormSelect from "../yoello-lib/modules/dynamicForms/FormComponents/FormSelect";
import FormSmallTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormSmallTextBox";
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";

export function createReportFormRows(t: (key: string) => string, momentFormat: string, hasTransactionFeeReport: boolean , update:boolean, enableDetailedLineItemReport:boolean, enableCustomerDataExport:boolean): IDynamicFormRow[] {
    const maxDate = moment().add("d", 1).hour(0).minute(0).seconds(0).format(momentFormat);

    let selectOptions = [
        { name: t(ReportType.Stock), value: t(ReportType.Stock) },
        { name: t(ReportType.Orders), value: t(ReportType.Orders) },
        { name: t(ReportType.TotalReport), value: t(ReportType.TotalReport) },
        { name: t(ReportType.AreaStock), value: t(ReportType.AreaStock) },
        { name: t(ReportType.OrderFeesReport), value: t(ReportType.OrderFeesReport) },
        // { name: t(ReportType.VATReport), value: t(ReportType.VATReport) },
    ];
    if (hasTransactionFeeReport) {
        selectOptions = [...selectOptions, { name: t(ReportType.Pay360TransactionFeeReport), value: t(ReportType.Pay360TransactionFeeReport) }]
    }
    if (enableDetailedLineItemReport) {
        selectOptions = [...selectOptions, { name: t(ReportType.OrderLineItemDetailReport), value: t(ReportType.OrderLineItemDetailReport) }]
    }
    if (enableCustomerDataExport) {
        selectOptions = [...selectOptions, { name: t(ReportType.CustomerDataExport), value: t(ReportType.CustomerDataExport) }]
    }
    return [
        {
            label: "profile.report.type", keyName: "report_type",
            Component: FormSelect,
            formProps: {
                selectOptions: selectOptions,
                //if the merchant after choosing an option changes the language ..selected option should be reset
                update:update
            },
            registerOptions: { required: true },
            inputProperties: { placeholder: t("profile.report.noItemSelected") }
        },
        {
            label: "profile.report.startdateside",
            keyName: "start_date_time",
            Component: FormSmallTextBox,
            formProps: {
                sideLabel: "",
                secondLabel: "",
            },
            registerOptions: { required: true },
            inputProperties: {
                type: "datetime-local",
                placeholder: t("profile.report.startdatesidePlaceholder"),
                inputProps: {
                    max: maxDate
                }
            }
        }, {
            label: "profile.report.enddateside",
            keyName: "end_date_time",
            Component: FormSmallTextBox,
            formProps: {
                sideLabel: "",
                secondLabel: "",
            },
            registerOptions: { required: true },
            inputProperties: {
                type: "datetime-local",
                placeholder: t("profile.report.enddatesidePlaceholder"),
                inputProps: {
                    max: maxDate
                }
            }
        }

    ];
}
